import { css } from '@emotion/react';

export {
  filterConditionsContainerStyles,
} from 'components/layout/Sidebar/Sidebar.styles';

export const datepickerContainerStyles = css`
  margin-bottom: 0;
  width: 100%;
`;

export const select2ContainerStyles = css`
  margin-bottom: 0;
  width: 100%;
`;

export const labelStyles = css`
  margin: 0;
`;

export const selectContainerStyles = css`
  width: 100%;
  display: flex;
  margin-bottom: 0;
`;
